import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { FinanceComponent } from '@app/features/dashboards/components/finance/finance.component'
import { DashboardOverviewComponent } from '@app/features/dashboards/components/dashboard-overview/dashboard-overview.component'

const routes: Routes = [
  {
    path: '',
    component: DashboardOverviewComponent,
    children: [
      { path: 'quantity', component: DashboardOverviewComponent },
      { path: 'finance', component: FinanceComponent },
      { path: 'downloads', component: DashboardOverviewComponent },
    ],
  },
]

@NgModule({ imports: [RouterModule.forChild(routes)], exports: [RouterModule] })
export class DashboardOverviewRoutingModule {}
